/**
 * This function is a way to get around the issue below
 * https://github.com/microsoft/TypeScript/issues/16069
 */
export const isPresent = function <T>(t: T | undefined | null | void): t is T {
    return t !== undefined && t !== null;
};
